import React, { Component } from "react"
import styled from "styled-components"
import { Translate, getActiveLanguage } from "react-localize-redux"

class EgiftHeaderMegaMenu extends Component {
	render() {
		const {
			openedMenu,
			onMegaNavEnter,
			onMegaNavLeave,
			translate,
			currentLanguage,
			isAuthenticated,
		} = this.props

		if (!openedMenu) {
			return null
		}

		return (
			<div
				id="menus"
				className="megaNav"
				onMouseLeave={onMegaNavLeave}
				onMouseEnter={onMegaNavEnter}>
				<StyledOl className="container">
					{openedMenu === "nav_0" && (
						<li className="fields" id="menu_0">
							<div className="region size4of5 menu_content">
								<ol className="blocks blocks-four-up">
									<li className="blocks-start">
										<p>
											<a
												href={translate(
													"mm.Link.coffee.OurCoffees"
												)}>
												<Translate id="mm.coffee.OurCoffees" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.OurCoffees.WholeBeanCoffee"
													)}>
													<Translate id="mm.coffee.OurCoffees.WholeBeanCoffee" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.OurCoffees.ViewAllCoffees"
													)}>
													<Translate id="mm.coffee.OurCoffees.ViewAllCoffees" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.coffee.FindYourPerfectCoffee"
												)}>
												<Translate id="mm.coffee.FindYourPerfectCoffee" />
											</a>
										</p>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.coffee.Espresso"
												)}>
												<Translate id="mm.coffee.Espresso" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.Espresso.TheIngredients"
													)}>
													<Translate id="mm.coffee.Espresso.TheIngredients" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.Espresso.TheBestEquipment"
													)}>
													<Translate id="mm.coffee.Espresso.TheBestEquipment" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.Espresso.WhoMakesIt"
													)}>
													<Translate id="mm.coffee.Espresso.WhoMakesIt" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.coffee.HowToBrewGreatCoffee"
												)}>
												<Translate id="mm.coffee.HowToBrewGreatCoffee" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.HowToBrewGreatCoffee.CoffeePress"
													)}>
													<Translate id="mm.coffee.HowToBrewGreatCoffee.CoffeePress" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.HowToBrewGreatCoffee.PourOver"
													)}>
													<Translate id="mm.coffee.HowToBrewGreatCoffee.PourOver" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.HowToBrewGreatCoffee.IcedPourOver"
													)}>
													<Translate id="mm.coffee.HowToBrewGreatCoffee.IcedPourOver" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.HowToBrewGreatCoffee.CoffeeBrewer"
													)}>
													<Translate id="mm.coffee.HowToBrewGreatCoffee.CoffeeBrewer" />
												</a>
											</li>
										</ol>
									</li>
									<li className="blocks-start">
										<p>
											<a
												href={translate(
													"mm.Link.coffee.EthicalSourcing"
												)}>
												<Translate id="mm.coffee.EthicalSourcing" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.EthicalSourcing.Coffee"
													)}>
													<Translate id="mm.coffee.EthicalSourcing.Coffee" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.EthicalSourcing.CoffeeQuality"
													)}>
													<Translate id="mm.coffee.EthicalSourcing.CoffeeQuality" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.EthicalSourcing.FarmerSupport"
													)}>
													<Translate id="mm.coffee.EthicalSourcing.FarmerSupport" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<Translate id="mm.coffee.LearnMore" />
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.LearnMore.StarbucksRoastSpectrum"
													)}>
													<Translate id="mm.coffee.LearnMore.StarbucksRoastSpectrum" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.LearnMore.FlavorsInYourCup"
													)}>
													<Translate id="mm.coffee.LearnMore.FlavorsInYourCup" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffee.LearnMore.CoffeeFAQ"
													)}>
													<Translate id="mm.coffee.LearnMore.CoffeeFAQ" />
												</a>
											</li>
										</ol>
									</li>
								</ol>
								<p className="menu_suggestion_title">
									<Translate id="mm.coffee.LookingForCoffeeBeverages" />{" "}
								</p>
								<ul className="menu_suggestion_links">
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate(
												"mm.Link.coffee.LookingForCoffeeBeverages.Drinks"
											)}>
											<Translate id="mm.coffee.LookingForCoffeeBeverages.Drinks" />
										</a>
									</li>
								</ul>
							</div>
							<div className="region size1of5 menu_promo">
								<a
									href={translate("mm.Link.coffee.side")}
									title="Blonde Roast">
									<p>
										<img
											src="https://en.starbucks.vn/media/blonde_roast_coffee_tcm89-15926.jpg"
											alt="Blonde Roast"
										/>
									</p>
									<p>
										<strong>
											<Translate id="mm.coffee.side.Title" />
										</strong>
									</p>
									<p>
										<Translate id="mm.coffee.side.Body" />
									</p>
								</a>
							</div>
						</li>
					)}
					{openedMenu === "nav_1" && (
						<li className="fields" id="menu_1">
							<div className="region size4of5 menu_content">
								<ol className="blocks blocks-four-up">
									<li className="blocks-start">
										<p>
											<a href={translate("mm.Link.menu.Drinks")}>
												<Translate id="mm.menu.Drinks" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Drinks.EspressoBeverages"
													)}>
													<Translate id="mm.menu.Drinks.EspressoBeverages" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Drinks.ChocolateBeverages"
													)}>
													<Translate id="mm.menu.Drinks.ChocolateBeverages" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Drinks.FrappuccinoBlendedCoffee"
													)}>
													<Translate id="mm.menu.Drinks.FrappuccinoBlendedCoffee" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Drinks.FrappuccinoBlendedCream"
													)}>
													<Translate id="mm.menu.Drinks.FrappuccinoBlendedCream" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Drinks.BrewedTea"
													)}>
													<Translate id="mm.menu.Drinks.BrewedTea" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<a href={translate("mm.Link.menu.Food")}>
												<Translate id="mm.menu.Food" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Food.Bakery"
													)}>
													<Translate id="mm.menu.Food.Bakery" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Food.Muffins"
													)}>
													<Translate id="mm.menu.Food.Muffins" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Food.Cookies"
													)}>
													<Translate id="mm.menu.Food.Cookies" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Food.Cakes"
													)}>
													<Translate id="mm.menu.Food.Cakes" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.menu.Food.ColdSandwiches"
													)}>
													<Translate id="mm.menu.Food.ColdSandwiches" />
												</a>
											</li>
										</ol>
									</li>
								</ol>
								<p className="menu_suggestion_title">
									<Translate id="mm.menu.LookingForCoffeeToDrinkAtHome" />{" "}
								</p>
								<ul className="menu_suggestion_links">
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate(
												"mm.Link.menu.LearnAboutTheStarbucksRoastSpectrum"
											)}>
											<Translate id="mm.menu.LearnAboutTheStarbucksRoastSpectrum" />
										</a>
									</li>
									<li className="navGroup_menu_sugList_item">
										<Translate id="mm.menu.LearnAboutTheStarbucksRoastSpectrum.Coffee" />
									</li>
								</ul>
							</div>
							<div className="region size1of5 menu_promo">
								<a
									href={translate("mm.Link.menu.side")}
									title="Real Food, Simply Delicious">
									<p>
										<img
											src="https://en.starbucks.vn/media/menu_blueberries_tcm89-16461.jpg"
											alt="Blue Berries"
										/>
									</p>
									<p>
										<strong>
											<Translate id="mm.menu.side.Title" />
										</strong>
									</p>
									<p>
										<Translate id="mm.menu.side.Body" />
									</p>
								</a>
							</div>
						</li>
					)}
					{openedMenu === "nav_2" && (
						<li className="fields" id="menu_2">
							<div className="region size4of5 menu_content">
								<ol className="blocks blocks-four-up">
									<li className="blocks-start">
										<p>
											<a
												href={translate(
													"mm.Link.coffeehouse.CoffeemasterProgram"
												)}>
												<Translate id="mm.coffeehouse.CoffeemasterProgram" />
											</a>
										</p>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.coffeehouse.OnlineCommunity"
												)}>
												<Translate id="mm.coffeehouse.OnlineCommunity" />
											</a>
										</p>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.coffeehouse.StoreDesign"
												)}>
												<Translate id="mm.coffeehouse.StoreDesign" />
											</a>
										</p>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.coffeehouse.Merchandise"
												)}>
												<Translate id="mm.coffeehouse.Merchandise" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.coffeehouse.Merchandise.Drinkware"
													)}>
													<Translate id="mm.coffeehouse.Merchandise.Drinkware" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffeehouse.Merchandise.Machines"
													)}>
													<Translate id="mm.coffeehouse.Merchandise.Machines" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.coffeehouse.Merchandise.Accessories"
													)}>
													<Translate id="mm.coffeehouse.Merchandise.Accessories" />
												</a>
											</li>
										</ol>
									</li>
								</ol>
								<p className="menu_suggestion_title">
									<Translate id="mm.coffeehouse.LookingForSomethingElse" />{" "}
								</p>
								<ul className="menu_suggestion_links">
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate("mm.Link.coffeehouse.Drinks")}
											title="Drinks">
											<Translate id="mm.coffeehouse.Drinks" />
										</a>
									</li>
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate(
												"mm.Link.coffeehouse.AboutUs"
											)}
											title="About Us">
											<Translate id="mm.coffeehouse.AboutUs" />
										</a>
									</li>
								</ul>
							</div>
							<div className="region size1of5 menu_promo">
								<a
									href={translate("mm.Link.coffeehouse.side")}
									title="Our Coffee Brings People Together">
									<p>
										<img
											src="https://en.starbucks.vn/media/Coffeehouse-Teaser_tcm89-3864.jpg"
											alt="Starbucks Our Coffee Brings People Together"
										/>
									</p>
									<p>
										<strong>
											<Translate id="mm.coffeehouse.side.Title" />
										</strong>
									</p>
									<p>
										<Translate id="mm.coffeehouse.side.Body" />
									</p>
								</a>
							</div>
						</li>
					)}
					{openedMenu === "nav_3" && (
						<li className="fields" id="menu_3">
							<div className="region size4of5 menu_content">
								<ol className="blocks blocks-four-up">
									<li className="blocks-start">
										<p>
											<a
												href={translate(
													"mm.Link.responsibility.EthicalSourcing"
												)}>
												<Translate id="mm.responsibility.EthicalSourcing" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.EthicalSourcing.CoffeeSourcing"
													)}>
													<Translate id="mm.responsibility.EthicalSourcing.CoffeeSourcing" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.EthicalSourcing.FarmerSupport"
													)}>
													<Translate id="mm.responsibility.EthicalSourcing.FarmerSupport" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.EthicalSourcing.TeaSourcing"
													)}>
													<Translate id="mm.responsibility.EthicalSourcing.TeaSourcing" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.EthicalSourcing.CocoaSourcing"
													)}>
													<Translate id="mm.responsibility.EthicalSourcing.CocoaSourcing" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.responsibility.Environment"
												)}>
												<Translate id="mm.responsibility.Environment" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.Environment.Recycling"
													)}>
													<Translate id="mm.responsibility.Environment.Recycling" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.Environment.Energy"
													)}>
													<Translate id="mm.responsibility.Environment.Energy" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.Environment.Water"
													)}>
													<Translate id="mm.responsibility.Environment.Water" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.Environment.GreenBuilding"
													)}>
													<Translate id="mm.responsibility.Environment.GreenBuilding" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.responsibility.Environment.ClimateChange"
													)}>
													<Translate id="mm.responsibility.Environment.ClimateChange" />
												</a>
											</li>
										</ol>
									</li>
								</ol>
								<p className="menu_suggestion_title">
									<Translate id="mm.responsibility.LookingForStarbucksInformation" />{" "}
								</p>
								<ul className="menu_suggestion_links">
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate(
												"mm.Link.responsibility.AboutUs"
											)}>
											<Translate id="mm.responsibility.AboutUs" />
										</a>
									</li>
									<li className="navGroup_menu_sugList_item">
										<Translate id="mm.responsibility.Coffee" />
									</li>
								</ul>
							</div>
							<div className="region size1of5 menu_promo">
								<div className="anchor">
									<p>
										<img
											src="https://en.starbucks.vn/media/responsibility-upsell-promo-image_tcm89-23593.JPG"
											alt="People Working At Farm"
										/>
									</p>
									<p>
										<strong>
											<Translate id="mm.responsibility.side.Title" />
										</strong>
									</p>
									<p>
										<Translate id="mm.responsibility.side.Body" />
									</p>
								</div>
							</div>
						</li>
					)}
					{openedMenu === "nav_4" && (
						<li className="fields" id="menu_4">
							<div className="region size4of5 menu_content">
								<ol className="blocks blocks-four-up">
									<li className="blocks-start">
										<p>
											<a
												href={translate(
													"mm.Link.aboutus.OurHeritage"
												)}>
												<Translate id="mm.aboutus.OurHeritage" />
											</a>
										</p>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.aboutus.OurCompany"
												)}>
												<Translate id="mm.aboutus.OurCompany" />
											</a>
										</p>
										<ol>
											<li>
												<a
													href={translate(
														"mm.Link.aboutus.OurCompany.MissionStatement"
													)}>
													<Translate id="mm.aboutus.OurCompany.MissionStatement" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.aboutus.OurCompany.BusinessEthicsAndCompliance"
													)}>
													<Translate id="mm.aboutus.OurCompany.BusinessEthicsAndCompliance" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.aboutus.OurCompany.DiversityAtStarbucks"
													)}>
													<Translate id="mm.aboutus.OurCompany.DiversityAtStarbucks" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.aboutus.OurCompany.OnlinePolicies"
													)}>
													<Translate id="mm.aboutus.OurCompany.OnlinePolicies" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<a
												href={translate(
													"mm.Link.aboutus.CareerCenter"
												)}>
												<Translate id="mm.aboutus.CareerCenter" />
											</a>
										</p>
									</li>
								</ol>
								<p className="menu_suggestion_title">
									<Translate id="mm.aboutus.LookingForStoreLocations" />{" "}
								</p>
								<ul className="menu_suggestion_links">
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate(
												"mm.Link.aboutus.CustomerService"
											)}
											title="Customer Service">
											<Translate id="mm.aboutus.CustomerService" />
										</a>
									</li>
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate(
												"mm.Link.aboutus.StoreLocator"
											)}
											title="Store Locator">
											<Translate id="mm.aboutus.StoreLocator" />
										</a>
									</li>
								</ul>
							</div>
							<div className="region size1of5 menu_promo">
								<a
									href={translate("mm.Link.aboutus.side")}
									title="A Different Kind of Company">
									<p>
										<img
											src="https://www.starbucks.vn/media/Teaser01_tcm90-3390.jpg"
											alt="Starbucks Espresso Cappuccino"
										/>
									</p>
									<p>
										<strong>
											<Translate id="mm.aboutus.side.Title" />
										</strong>
									</p>
									<p>
										<Translate id="mm.aboutus.side.Body" />
									</p>
								</a>
							</div>
						</li>
					)}
					{openedMenu === "nav_5" && (
						<li className="fields" id="menu_5">
							<div className="region size4of5 menu_content">
								<ol className="blocks blocks-four-up">
									<li className="blocks-start">
										<p>
											{isAuthenticated ? (
												<a href={`/${currentLanguage}/cards`}>
													<Translate id="mm.card.ManageYourCard" />
												</a>
											) : (
												<a href={`/${currentLanguage}/`}>
													<Translate id="mm.card.ManageYourCard" />
												</a>
											)}
										</p>
										<ol>
											<li>
												<a href={`/${currentLanguage}/sign-in`}>
													<Translate id="mm.card.ManageYourCard.LoginCreateAnAccount" />
												</a>
											</li>
											<li>
												{isAuthenticated ? (
													<a
														href={`/${currentLanguage}/transactions`}>
														<Translate id="mm.card.ManageYourCard.ViewTransactions" />
													</a>
												) : (
													<a href={`/${currentLanguage}/`}>
														<Translate id="mm.card.ManageYourCard.ViewTransactions" />
													</a>
												)}
											</li>
											<li>
												{isAuthenticated ? (
													<a href={`/${currentLanguage}/cards`}>
														<Translate id="mm.card.ManageYourCard.ReportLostStolen" />
													</a>
												) : (
													<a href={`/${currentLanguage}/`}>
														<Translate id="mm.card.ManageYourCard.ReportLostStolen" />
													</a>
												)}
											</li>
										</ol>
									</li>
									<li>
										<p>
											<Translate id="mm.card.LearnMore" />
										</p>
										<ol>
											<li>
												<a href={`/${currentLanguage}/`}>
													<Translate id="mm.card.LearnMore.StarbucksRewards" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.card.LearnMore.ProgramTermsAndConditions"
													)}>
													<Translate id="mm.card.LearnMore.ProgramTermsAndConditions" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.card.LearnMore.PrivacyStatement"
													)}>
													<Translate id="mm.card.LearnMore.PrivacyStatement" />
												</a>
											</li>
											<li>
												<a
													href={translate(
														"mm.Link.card.LearnMore.CardFaqs"
													)}>
													<Translate id="mm.card.LearnMore.CardFaqs" />
												</a>
											</li>
										</ol>
									</li>
									<li>
										<p>
											<Translate id="mm.card.StarbuckseGifting" />
										</p>
										<ol>
											<li>
												<a
													href={`/${currentLanguage}/landing-egift`}>
													<Translate id="mm.card.StarbuckseGifting.SendeGiftingNow" />
												</a>
											</li>
										</ol>
									</li>
								</ol>
								<p className="menu_suggestion_title">
									<Translate id="mm.card.LookingForStoreLocations" />{" "}
								</p>
								<ul className="menu_suggestion_links">
									<li className="navGroup_menu_sugList_item">
										<a
											className="link"
											href={translate("mm.Link.card.StoreLocator")}
											title="Store Locator">
											<Translate id="mm.card.StoreLocator" />
										</a>
									</li>
								</ul>
							</div>
							<div className="region size1of5 menu_promo">
								<a href={`/${currentLanguage}/`} target="_self">
									<p>
										<img
											src="https://en.starbucks.vn/media/card-teaser_tcm89-25200.jpg"
											alt="Starbucks Rewards"
										/>
									</p>
									<p>
										<strong>
											<Translate id="mm.card.side.Title" />
										</strong>
									</p>
									<p>
										<Translate id="mm.card.side.Body" />
									</p>
								</a>
							</div>
						</li>
					)}
				</StyledOl>
			</div>
		)
	}
}

const StyledOl = styled.ol`
	list-style: none;

	@media screen and (max-width: 767px) {
		display: none;
	}
`

export default EgiftHeaderMegaMenu



// WEBPACK FOOTER //
// ./src/views/layout/EgiftHeaderMegaMenu.js